import { FLIP_CARD } from '../income-tax/static/types';
import { FlipCard } from './FlipCard';

interface FLIP_CARD_WRAPPER_PROPS {
  cardData: FLIP_CARD[];
  trackLabel: string;
  isVariant?: boolean;
}

export const FlipCardWrapper = ({
  cardData,
  trackLabel,
  isVariant,
}: FLIP_CARD_WRAPPER_PROPS): JSX.Element => {
  return (
    <div className="gap-7 grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 flex-wrap w-full mt-12 sm:mt-9 sm:flex-col">
      {cardData.map((item) => (
        <FlipCard
          cardItem={item}
          key={item.title}
          trackLabel={trackLabel}
          isVariant={isVariant}
        />
      ))}
    </div>
  );
};
